import { Users, Shield, UserX, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PeopleBulkActionsProps {
  selectedCount: number;
  onAssignToTeam: () => void;
  onChangeRole: () => void;
  onDeactivate: () => void;
  onClearSelection: () => void;
}

export function PeopleBulkActions({
  selectedCount,
  onAssignToTeam,
  onChangeRole,
  onDeactivate,
  onClearSelection,
}: PeopleBulkActionsProps) {
  if (selectedCount <= 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 animate-in slide-in-from-bottom-5 duration-200">
      <div className="flex items-center gap-2 bg-background border shadow-card-elevated rounded-lg px-4 py-2">
        <span className="text-sm font-medium text-foreground whitespace-nowrap">
          {selectedCount} selected
        </span>

        <div className="h-4 w-px bg-border mx-1" />

        <Button variant="ghost" size="sm" onClick={onAssignToTeam}>
          <Users className="h-4 w-4" />
          Assign to Team
        </Button>

        <Button variant="ghost" size="sm" onClick={onChangeRole}>
          <Shield className="h-4 w-4" />
          Edit Permissions
        </Button>

        <Button variant="ghost" size="sm" onClick={onDeactivate} className="text-destructive hover:text-destructive">
          <UserX className="h-4 w-4" />
          Deactivate
        </Button>

        <div className="h-4 w-px bg-border mx-1" />

        <Button variant="ghost" size="icon" onClick={onClearSelection} className="h-8 w-8">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
